import { render, staticRenderFns } from "./SizeDropdown.vue?vue&type=template&id=59478628&"
import script from "./SizeDropdown.vue?vue&type=script&lang=js&"
export * from "./SizeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports